const LOGIN_SUCCESS_MESSAGE_TYPE = 'LoginSuccess';

export function isLoginSuccessMessage(data: unknown): boolean {
  return (
    data !== null &&
    typeof data === 'object' &&
    (data as { messageType?: unknown }).messageType ===
      LOGIN_SUCCESS_MESSAGE_TYPE
  );
}
